import logo from '../logo-rh-fenix-transparente.png';

import {
  FiGrid,
  FiUsers,
  FiBriefcase,
  FiClock,
  FiFileText,
  FiSettings,
  FiLogOut
} from 'react-icons/fi';

function Sidebar({
  menu,
  setMenu,
  logout
}) {

  return (

    <aside className="sidebar">

      <div className="sidebar-logo">
        <img
          src={logo}
          alt="RH Fênix"
        />
      </div>

      <nav className="sidebar-menu">

        <button
          className={menu === 'dashboard' ? 'active' : ''}
          onClick={() => setMenu('dashboard')}
        >
          <FiGrid />
          Dashboard
        </button>

        <button
          className={menu === 'colaboradores' ? 'active' : ''}
          onClick={() => setMenu('colaboradores')}
        >
          <FiUsers />
          Colaboradores
        </button>

        <button
          className={menu === 'empresas' ? 'active' : ''}
          onClick={() => setMenu('empresas')}
        >
          <FiBriefcase />
          Empresas
        </button>

        <button
          className={menu === 'ponto' ? 'active' : ''}
          onClick={() => setMenu('ponto')}
        >
          <FiClock />
          Controle de Ponto
        </button>

<button
  className={menu === 'configuracoes' ? 'active' : ''}
  onClick={() => setMenu('configuracoes')}
>
  <FiSettings />
  Configurações
</button>  
      <button
          className={menu === 'relatorios' ? 'active' : ''}
          onClick={() => setMenu('relatorios')}
        >
          <FiFileText />
          Relatórios
        </button>

      </nav>

    </aside>
  );
}

export default Sidebar;
